module.exports = __webpack_public_path__ + "img/рз_18.8fb87998.png";